import type { Route } from 'next';
import Link from 'next/link';
import layoutStyles from '../../../../styles/modules/layout.module.scss';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import type { VariantType } from '../../../../types';
import type { Faq } from '../../types';
import styles from './FaqDetail.module.scss';

export interface FaqDetailProps {
  faq: Faq;
  faqListPath: string;
  contactPath: string;
  FaqTagListComponent: React.ComponentType<{ items: Array<{ child: React.ReactNode }> }>;
  LinkButtonComponent: React.ComponentType<{
    href: string | URL | { [key: string]: unknown };
    outlined?: boolean;
    children: React.ReactNode;
    styleVariant?: VariantType;
    color?: string;
    bgColor?: string;
    [key: string]: unknown;
  }>;
}

function FaqDetail({ faq, faqListPath, contactPath, FaqTagListComponent, LinkButtonComponent }: FaqDetailProps) {
  return (
    <article data-testid='faq-article'>
      <header className={styles.header}>
        <h1 className={`${styles.title} ${utilsStyles.textBold}`}>{faq.title}</h1>
      </header>
      <div
        className={styles.text}
        // biome-ignore lint/security/noDangerouslySetInnerHtml: HTML content from API
        dangerouslySetInnerHTML={{
          __html: faq.description,
        }}
      />
      <FaqTagListComponent
        items={faq.tags.map((tag) => ({
          child: <>#{tag.name}</>,
        }))}
      />
      <hr className={utilsStyles.mtMedium} />
      <div className={utilsStyles.mtSmall} data-testid='faq-resolution-text'>
        <p className={`${utilsStyles.textSmall} ${utilsStyles.textBold}`}>解決しましたか？</p>
        <p className={`${utilsStyles.textSmall} ${utilsStyles.mtXSmall}`}>
          解決しない場合は別の「
          <Link href={faqListPath as Route} className={utilsStyles.textUnderlined}>
            よくある質問
          </Link>
          」をご覧になるか、
          <br />「
          <Link href={contactPath as Route} className={utilsStyles.textUnderlined}>
            問い合わせフォーム
          </Link>
          」よりご質問ください。
        </p>
      </div>
      <div className={`${utilsStyles.mtMedium} ${layoutStyles.centeredBtnWrapper}`}>
        <LinkButtonComponent href={faqListPath} outlined={true} dataTestId='faq-back-link'>
          一覧へ戻る
        </LinkButtonComponent>
      </div>
    </article>
  );
}

export default FaqDetail;
